import { render, staticRenderFns } from "./WebhookNew.vue?vue&type=template&id=45c526cc"
import script from "./WebhookNew.vue?vue&type=script&lang=ts"
export * from "./WebhookNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports